import { useState } from "react";
import { Link } from "react-router-dom";
import { TOC_ITEMS, SYSTEMS_REFERENCE, META } from "../../data/reportContent";

export const ReportNav = () => {
  const [activePanel, setActivePanel] = useState(null);

  const goTo = (id) => {
    setActivePanel(null);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const togglePanel = (name) => {
    setActivePanel((cur) => (cur === name ? null : name));
  };

  return (
    <nav className="report-nav no-print" data-testid="report-nav">
      <div className="report-nav-inner">
        <div className="report-nav-title">
          {META.title}
          <span>{META.subtitle}</span>
        </div>
        <div className="report-nav-actions">
          <button
            className="report-nav-link"
            onClick={() => togglePanel("systems")}
            data-testid="report-systems-toggle"
          >
            {activePanel === "systems" ? "Close" : "Systems"}
          </button>
          <button
            className="report-nav-link"
            onClick={() => togglePanel("contents")}
            data-testid="report-toc-toggle"
          >
            {activePanel === "contents" ? "Close" : "Contents"}
          </button>
          <Link className="report-nav-link" to="/executive-summary" data-testid="report-nav-execsummary-link">
            Executive Summary
          </Link>
          <Link className="report-nav-link" to="/report/print" data-testid="report-nav-print-link">
            Print / Save PDF
          </Link>
        </div>
      </div>

      <div className={`report-toc-panel ${activePanel === "contents" ? "open" : ""}`} data-testid="report-toc-panel">
        <div className="report-toc-list">
          {TOC_ITEMS.map((item) => (
            <a
              key={item.id}
              href={`#${item.id}`}
              data-testid={`toc-link-${item.id}`}
              onClick={(e) => {
                e.preventDefault();
                goTo(item.id);
              }}
            >
              {item.label}
            </a>
          ))}
        </div>
      </div>

      <div className={`report-toc-panel systems-panel ${activePanel === "systems" ? "open" : ""}`} data-testid="report-systems-panel">
        <div className="systems-panel-intro">Who to use for what: a quick reference for administrators and staff.</div>
        <div className="systems-list">
          {SYSTEMS_REFERENCE.map((s) => (
            <div className="systems-row" key={s.term} data-testid={`systems-row-${s.term.toLowerCase().replace(/[^a-z]/g, "-")}`}>
              <span className="systems-term">{s.term}</span>
              <span className="systems-def">{s.def}</span>
            </div>
          ))}
        </div>
      </div>
    </nav>
  );
};
